export function isFactoryProvider(provider) {
    return !!provider.useFactory;
}
